import { useMutation } from '@tanstack/react-query';
import {
  type ContactDetails,
  WithLeadSource,
  yad1Client,
} from '@y2/api-clients/yad1';

const client = yad1Client();

export const getSubmitContactDetailsOptions = () => {
  return {
    mutationKey: ['yad1-contact-us'],
    mutationFn: (formData: WithLeadSource<ContactDetails>) =>
      client.submitContactDetails(formData).then((res) => res.data.data),
  };
};

export const useSubmitContactDetails = () =>
  useMutation(getSubmitContactDetailsOptions());
